import { Reveal } from "./Reveal";
import { ChevronRight } from "lucide-react";

const DRIVER_IMG =
  "https://images.pexels.com/photos/14797991/pexels-photo-14797991.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const steps = [
  {
    num: "01",
    title: "Discovery",
    text: "Tell us about your goals, available resources, timeline and what you want to build.",
  },
  {
    num: "02",
    title: "Business Review",
    text: "We determine whether the I Stay Trucking operating model is appropriate for your situation.",
  },
  {
    num: "03",
    title: "Launch Plan",
    text: "Qualified prospects receive a customized conversation about company setup, operating requirements, timeline and I Stay Trucking's management program.",
  },
  {
    num: "04",
    title: "Build & Operate",
    text: "If both sides decide to move forward, we begin building the operational foundation and preparing the carrier for launch.",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="bg-[#050505] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-orange-500 mb-6" data-testid="how-eyebrow">
            How It Works
          </p>
          <h2
            className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[1.05] text-white"
            data-testid="how-headline"
          >
            From Idea To <span className="text-orange-500">Operating Carrier.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-5 gap-10 md:gap-16 items-start">
          <Reveal className="md:col-span-2">
            <div className="relative md:sticky md:top-28">
              <img
                src={DRIVER_IMG}
                alt="Trucking professional"
                className="w-full h-[420px] md:h-[560px] object-cover border border-neutral-800"
                data-testid="how-driver-image"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/70 px-6 py-4 border-t border-orange-500">
                <p className="font-display text-sm font-semibold uppercase tracking-[0.25em] text-orange-500">
                  Own the company. We'll run it.
                </p>
              </div>
            </div>
          </Reveal>

          <div className="md:col-span-3 flex flex-col gap-4">
            {steps.map((s, i) => (
              <Reveal key={s.num} delay={0.08 * i}>
                <div
                  data-testid={`step-card-${i}`}
                  className="group flex gap-6 md:gap-8 border border-neutral-800 bg-[#121212] p-8 transition-all duration-200 hover:-translate-y-1 hover:border-orange-500/70"
                >
                  <span className="font-display text-5xl md:text-6xl font-bold text-neutral-800 transition-colors duration-200 group-hover:text-orange-500">
                    {s.num}
                  </span>
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-white">
                      {s.title}
                    </h3>
                    <p className="mt-2 text-sm md:text-base text-neutral-400">{s.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}

            <Reveal delay={0.35}>
              <a
                href="#get-started"
                data-testid="how-cta"
                className="mt-4 inline-flex items-center gap-2 bg-orange-500 px-8 py-5 font-display text-base md:text-lg font-semibold uppercase tracking-wider text-white transition-all duration-200 hover:bg-orange-600 hover:-translate-y-1"
              >
                Start With A Discovery Call
                <ChevronRight size={20} />
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
